import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { cellStyle, truncateStyle } from './constants';
export var TableBodyCell = styled.td(_templateObject(), function (props) {
  return truncateStyle(props);
}, cellStyle);